export { default as Admin } from './Admin'



// WEBPACK FOOTER //
// ./src/app/components/index.js